import ConflictComponent from '../components/ConflictComponent';
import { ComponentIds } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import { PlannerEcsSystem } from './System';
export class ConflictOutlineSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'ConflictOutlineSystem', ConflictComponent.id);
        const entityManager = this.coreApi.getServices().entityManager;
        entityManager.subscribeEntityRemoved(entity => this.onEntityRemoved(entity));
    }
    /**
     * Adds outlined component to entity with conflict and
     * removes the outlined component from the selected entity
     */
    onAdd(entity) {
        entity.addComponent(new OutlinedComponent());
        const selectedEntity = this.coreApi.entities.findSelectedEntity();
        if (selectedEntity && !selectedEntity.hasComponent(ConflictComponent.id)) {
            selectedEntity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        }
    }
    onUpdate() { }
    /**
     * Removes the outlined component from entity with conflict and
     * adds the outlined component to the selected entity
     */
    onRemove(entity) {
        entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        const selectedEntity = this.coreApi.entities.findSelectedEntity();
        if (selectedEntity) {
            selectedEntity.addComponent(new OutlinedComponent());
        }
    }
    /**
     * Removes conflict component from deleted entity.
     * Needed since undo/redo will remember which components the
     * entity had when removed
     */
    onEntityRemoved(entity) {
        if (entity.hasComponent(ConflictComponent.id)) {
            entity.removeComponent(ConflictComponent.id);
        }
    }
}
//# sourceMappingURL=ConflictOutlineSystem.js.map